export default{
    SAVE_ATTRINFO: "SAVE_ATTRINFO",
    SAVE_OBJECT:"SAVE_OBJECT"
}